import graphql__5a43adeca30dc9623cab from "./__generated__/CustomerViewQuery.graphql.ts";import * as React from "react";
import {graphql} from "react-relay";
import {Outlet} from "react-router";
import CustomerAccountHeader from "./CustomerAccountHeader";
import {connect, ConnectedProps} from "react-redux";
import {hideModal, showModal} from "../store/actions";
import BreadcrumbNavigation from "./navigation/BreadcrumbNavigation";
import {loadQuery, usePreloadedQuery} from "react-relay/hooks";
import CustomerViewQuery, {CustomerViewQuery as CustomerViewQueryType} from "./__generated__/CustomerViewQuery.graphql";
import SecondaryNavigation from "./navigation/SecondaryNavigation";
import {useIntl} from "react-intl";

type CustomerViewParams = {
    prepared: any
};

const connector = connect(undefined, {
    dispatchShowModal: showModal,
    dispatchHideModal: hideModal
});

type CustomerViewProps = CustomerViewParams & ConnectedProps<typeof connector>;

const CustomerView: React.FC<CustomerViewProps> = (props) => {
    const intl = useIntl();

    const {customerAccount} = usePreloadedQuery<CustomerViewQueryType>(
        graphql__5a43adeca30dc9623cab,
        props.prepared.customerViewQuery,
    );
    if (customerAccount == null) {
        return <p>Customer account not found</p>;
    }

    const breadcrumbNavigationItems = [
        {label: intl.formatMessage({id: 'breadcrumb.customers'}), to: '/customers'},
        {label: customerAccount.customerName, to: '/customers/' + customerAccount.id},
    ]

    const secondaryNavigationItems = [
        {
            label: intl.formatMessage({id: 'tab.customer'}),
            to: '/customers/' + customerAccount.id + '/account'
        },
        {
            label: intl.formatMessage({id: 'tab.activities'}),
            to: '/customers/' + customerAccount.id + '/activities'
        },
        {
            label: intl.formatMessage({id: 'tab.contacts'}),
            to: '/customers/' + customerAccount.id + '/contacts'
        },
        {
            label: intl.formatMessage({id: 'tab.payment'}),
            to: '/customers/' + customerAccount.id + '/payment'
        },
    ]

    return (
        <>
            <BreadcrumbNavigation items={breadcrumbNavigationItems}/>
            <CustomerAccountHeader customerAccount={customerAccount}/>
            <SecondaryNavigation items={secondaryNavigationItems}/>
            <div className="mx-auto lg:px-8 grid grid-cols-1 gap-x-4 gap-y-8">
                <Outlet context={customerAccount} key={customerAccount.id}/>
            </div>
        </>
    );
}

export default connector(CustomerView);

function prepare_CustomerView(params, relayEnvironment) {
    return {
        customerViewQuery: loadQuery(
            relayEnvironment,
            CustomerViewQuery,
            {
                id: params.id,
            },
            {fetchPolicy: 'store-and-network'},
        ),
    }
}

export {prepare_CustomerView};
